export type EntityStatusColor = 'green' | 'gray' | 'red';

const GREEN_STATUSES = ['active', 'registered', 'good standing', 'live'];

const GRAY_STATUSES = [
  'dormant',
  'administration',
  'receivership',
  'insolvent',
  'liquidation',
  'converted',
];

const RED_STATUSES = [
  'dissolved',
  'struck off',
  'removed',
  'terminated',
  'ceased',
  'closed',
  'wound up',
  'bankruptcy',
  'revoked',
  'suspended',
  'not active',
  'inactive',
];

export const getEntityStatusColor = (
  status: string | null | undefined,
): EntityStatusColor | null => {
  if (!status) {
    return null;
  }

  const normalizedStatus = status.toLowerCase().trim();

  if (GREEN_STATUSES.includes(normalizedStatus)) {
    return 'green';
  }

  if (GRAY_STATUSES.includes(normalizedStatus)) {
    return 'gray';
  }

  if (RED_STATUSES.includes(normalizedStatus)) {
    return 'red';
  }

  return null;
};
